import { HrefLangs } from "@/src/utils/hreflangs/types"

/**
 * Whether the given string is an hreflang key the site publishes.
 */
export const isHrefLangKey = (key: string): boolean => HrefLangs.includes(key)
